import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { ContentContainer as HXContentContainer } from "./HXMobilePage.styles";
import { TitleHeaderView } from "./HXMobileTitleHeader";
import { PageWithFixedHeaderAndFooterContent, PatientConsentParent } from "./PatientConsentManagerShared.styles";
import { useViewModel } from "./useViewModel";
import { addDisplayName } from "../Infra/display-name";
import { PatientLoginVerifyPhoneViewModel } from "./PatientLoginVerifyPhoneViewModel";
import { VerifyOTPView } from "./VerifyOTPView";
export const PatientLoginVerifyPhoneView = observer((props) => {
    const model = useViewModel(PatientLoginVerifyPhoneViewModel, props.container);
    return (_jsx(PageWithFixedHeaderAndFooterContent, { isHeaderAndFooterFixed: false, children: _jsx(PatientConsentParent, { children: _jsxs(HXContentContainer, { children: [_jsx(TitleHeaderView, { showBottomBorder: false, title: undefined, showLogo: true, padding: "48px 0px 32px 0px" }), _jsx(VerifyOTPView, { model: model, animate: false })] }) }) }));
});
addDisplayName(PatientLoginVerifyPhoneView, "PatientLoginVerifyPhoneView");
